import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BannerService } from '../services/banner.service';

@Component({
  selector: 'app-popup-banner',
  standalone: true,
  imports: [CommonModule, HttpClientModule],
  templateUrl: './popup-banner.component.html',
  styleUrl: './popup-banner.component.scss'
})
export class PopupBannerComponent implements OnInit {
  showPopup: boolean = false;
  bannerData: any = null;

  constructor(private bannerService: BannerService) {}

  ngOnInit(): void {
    this.loadBanner();
  }

  loadBanner(): void {
    const today = new Date().toISOString();

    this.bannerService.getActiveBanners(today, true).subscribe((res) => {
      const validBanners = res.filter(banner => {
        const start = new Date(banner.startDate);
        const end = new Date(banner.endDate);
        const now = new Date();
        return start <= now && now <= end && banner.isActive;
      });

      if (validBanners.length > 0) {
        this.bannerData = validBanners[0];
        this.showPopup = true;
      }
    });
  }

  closePopup(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.showPopup = false;
  }
}
